import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import homeLoanImg from '../assets/images/FrontPage/home-loan-mortbuzz.jpg';
import Seo from "../components/Seo";

/*import "./styles.css"; // optional: move inline styles here or use Tailwind*/

const MortbuzzHomeLoanOffer = () => {
  const [loanAmount, setLoanAmount] = useState(0);
  const [interestRate, setInterestRate] = useState(0);
  const [loanTenure, setLoanTenure] = useState(0);
  const [emiResult, setEmiResult] = useState(null);

  const calculateEMI = () => {
    const principal = parseFloat(loanAmount);
    const annualInterest = parseFloat(interestRate);
    const tenureYears = parseFloat(loanTenure);
    const monthlyInterest = annualInterest / 12 / 100;
    const numberOfPayments = tenureYears * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, numberOfPayments)) /
      (Math.pow(1 + monthlyInterest, numberOfPayments) - 1);

    if (!isNaN(emi)) {
      setEmiResult(`Monthly EMI: ₹${emi.toFixed(2)}`);
    } else {
      setEmiResult("Please enter valid inputs.");
    }
  };

  return (
    <>

    <Seo
        title="Exclusive Home Loan Offers – Low Interest Rates & Special Deals | Mortbuzz"
        description="Grab the best home loan offers with Mortbuzz. Enjoy exclusive low interest rates, zero hidden charges, quick approval, and customized EMI plans for your dream home."
        keywords="home loan offers, special home loan rates, best home loan deal, home loan discount, low interest home loan"
        canonical="https://www.mortbuzz.in/mortbuzz-home-loan-offer"
      />



    <div style={{ backgroundColor: "#0e0e0e", color: "#e0f7fa", fontFamily: "Poppins, sans-serif" }}>
      <header className="text-white text-center py-3" style={{ backgroundColor: "#00e5ff", fontWeight: "bold", fontSize: "1.5rem", boxShadow: "0 4px 10px rgba(0, 229, 255, 0.2)" }}>
        Mortbuzz Cashback Offer
      </header>

      <section className="hero-section d-flex align-items-center justify-content-center text-center" style={{ backgroundImage: `url(${homeLoanImg})`, backgroundSize: "cover", backgroundPosition: "center", height: "100vh", position: "relative" }}>
        <div style={{ position: "absolute", inset: 0, background: "rgba(0, 0, 0, 0.6)" }}></div>
        <div className="hero-content position-relative z-1 text-white p-4">
          <h1 style={{ fontSize: "3.5rem", color: "#00e5ff" }}>Unlock Cashback on Your Home Loan</h1>
          <p>Apply now and save on processing fees, legal & technical charges, notice & intimation, stamp duty and more!</p>
          <a href="emi-calculator" className="cta-button btn btn-info text-dark fw-bold me-3 mt-3">Calculate EMI</a>
          <a href="apply-loan" className="cta-button btn btn-info text-dark fw-bold mt-3">Apply Now</a>
        </div>
      </section>

      <section className="offers d-flex flex-wrap justify-content-center gap-4 py-5">
        {[
          { title: "₹1 Cr Loan", cashback: "All applicable bank charges are paid by MortBuzz at the time of disbursement.", benefits: ["Legal & Technical Charges", "Stamp Duty", "Notice Fees"] },
          { title: "₹50 Lakh Loan", cashback: "50% applicable bank charges are paid by MortBuzz at the time of disbursement.", benefits: ["Legal & Technical Charges", "Stamp Duty", "Notice Fees"] },
          { title: "₹20 Lakh Loan", cashback: "20% applicable bank charges are paid by MortBuzz at the time of disbursement.", benefits: ["Legal & Technical Charges", "Stamp Duty", "Notice Fees"] }
        ].map((offer, index) => (
          <div key={index} className="offer-card border border-info rounded-4 p-4 text-white" style={{ backgroundColor: "#1c1c1c", width: 300, boxShadow: "0 6px 20px rgba(0, 229, 255, 0.15)" }}>
            <h2 className="text-info mb-3">{offer.title}</h2>
            <p>{offer.cashback} on:</p>
            <ul>
              {offer.benefits.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      <section id="calculator" className="loan-calculator text-white mx-auto py-5" style={{ maxWidth: 400 }}>
        <h3 className="text-white mb-4">Loan EMI Calculator</h3>
        <input type="number" className="form-control mb-3" placeholder="Loan Amount (₹)" onChange={(e) => setLoanAmount(e.target.value)} />
        <input type="number" className="form-control mb-3" placeholder="Interest Rate (%)" onChange={(e) => setInterestRate(e.target.value)} />
        <input type="number" className="form-control mb-3" placeholder="Loan Tenure (Years)" onChange={(e) => setLoanTenure(e.target.value)} />
        <button className="btn btn-info text-dark fw-bold w-100" onClick={calculateEMI}>Calculate EMI</button>
        <div className="mt-3 text-center">{emiResult}</div>
      </section>

      <section className="loan-types d-flex flex-wrap justify-content-center gap-4 py-5">
        {[
          { type: "Home Loans", rate: "7.10% p.a*" },
          { type: "Business Loans", rate: "9.00% p.a*" },
          { type: "Personal Loans", rate: "10.35% p.a*" },
          { type: "Education Loans", rate: "7.10% p.a*" },
          { type: "Car Loans", rate: "7.60% p.a*" },
          { type: "Loan Against Property", rate: "8.40% p.a*" }
        ].map((loan, index) => (
          <div key={index} className="loan-card border border-info rounded-4 p-4 text-white" style={{ backgroundColor: "#1c1c1c", width: 300, boxShadow: "0 6px 20px rgba(0, 229, 255, 0.15)" }}>
            <h2 className="text-info mb-2">{loan.type}</h2>
            <p className="mb-3">Starting at {loan.rate}</p>
            <a className="btn btn-info text-dark fw-bold" href="apply-now">Apply</a>
          </div>
        ))}
      </section>

      <a href="https://wa.me/919876543210?text=I'm%20interested%20in%20your%20loan%20offers" target="_blank" className="whatsapp-button btn" style={{ position: "fixed", bottom: 20, right: 20, backgroundColor: "#25D366", color: "white", padding: "12px 18px", borderRadius: 50, fontSize: 14, boxShadow: "0 4px 6px rgba(0,0,0,0.2)", zIndex: 1000 }}>
        💬 Chat on WhatsApp
      </a>

      <footer className="text-center py-3" style={{ backgroundColor: "#0a0a0a", color: "#aaa", fontSize: "0.9rem" }}>
        © 2025 Mortbuzz Solutions Pvt. Ltd. | All Rights Reserved
      </footer>
    </div>
    </>
  );
};

export default MortbuzzHomeLoanOffer;
